import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  GLOBAL_FETCH_START,
  GLOBAL_FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
} from "appRedux/constants";

const INIT_STATE = {
  display: false,
  error: "",
  loading: false,
  message: "",
  global_loading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GLOBAL_FETCH_START: {
      return { ...state, global_loading: true };
    }
    case GLOBAL_FETCH_SUCCESS: {
      return { ...state, global_loading: false };
    }
    case FETCH_START: {
      return { ...state, error: "", message: "", loading: true };
    }
    case FETCH_SUCCESS: {
      return {
        ...state,
        error: "",
        message: "",
        loading: false,
        display: true,
      };
    }
    case SHOW_MESSAGE: {
      return { ...state, error: "", message: action.payload, loading: false };
    }
    case FETCH_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
        display: true,
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        loading: false,
        error: "",
        message: "",
        display: false,
      };
    }
    default:
      return state;
  }
};
